import React, { Component } from 'react'
import { connect } from 'react-redux'
import emailjs from 'emailjs-com'
import Fade from 'react-reveal/Fade'

import { SERVICE_ID, USER_ID, TEMPLATE_ID } from './../../Data/Data'

export class Contact extends Component {
    constructor() {
        super()
        this.sendEmail = this.sendEmail.bind(this)
        this.state = {
            status: ""
        }
    }

    sendEmail(e) {
        e.preventDefault();
        emailjs.sendForm(SERVICE_ID, TEMPLATE_ID, "#contactForm", USER_ID)

        document.getElementById("contact").style.display = "none";
        document.getElementById("thankyou").style.display = "block";

    }

    render() {
        return (
            <div>
                <div id="contact" className="jumbotron sec-width shadow mx-auto bg-color-grey">
                    <h6 className="heading-font bg-color-heading pl-3 rounded">Contact Us</h6>
                    <form id="contactForm" className="contactForm" >
                        <div className="bg-color-white rounded body-font p-3">
                            <div className="form-group">
                                <label for="exampleInputEmail1">Email address</label>
                                <input name="email" type="email" className="input-width form-control" id="exampleInputEmail1" aria-describedby="emailHelp" />
                                <small id="emailHelp" className="form-text text-muted">We'll never share your email with anyone else.</small>
                            </div>
                            <div class="form-group">
                                <label for="exampleInputPassword1">Message</label><br />
                                <small className="text-muted">Please list your name and any other contact details below along with your request</small>
                                <textarea name="message" rows="5" type="text" class="form-control" id="exampleInputPassword1" />
                            </div>

                            <button type="submit" onClick={this.sendEmail} className="btn btn-primary">Submit</button>
                        </div>
                    </form>
                </div>

                <Fade>
                    <div id="thankyou" style={{ display: "none" }}>
                        <div className="jumbotron w-75 shadow mx-auto bg-color-grey">
                            <h6 className="display-2 dm-sans bg-color-white shadow pl-3 rounded mb-3">Thank You!</h6>
                            <p className="antic bg-color-white shadow pl-3 rounded">Your email has been sent to the BluePrintLegal team!</p>
                        </div>

                    </div>
                </Fade>
            </div>
        )
    }
}

const mapStateToProps = (state) => ({
    currentEmail: state.currentEmail
})

const mapDispatchToProps = {

}

export default connect(mapStateToProps, mapDispatchToProps)(Contact)
